import {Button, Card, CardContent, CardHeader, makeStyles, Theme} from '@material-ui/core';
import React, {useState} from 'react';
import {BillingParty} from '../../../graphql/billing_party.datatypes';
import {PaymentsListContent} from '../../Payments/PaymentsList/PaymentsList';
import {Payment, PaymentStatus, PaymentType} from '../../../graphql/payments.datatypes';
import PaymentEditModal from '../../Payments/PaymentEditModal';
import moment from 'moment';
import PaymentCheckoutFrame from '../../Payments/PaymentCheckoutFrame';

const useStyles = makeStyles((theme: Theme) => ({
    container: {
        marginTop: theme.spacing(3),
        width: '100%',
        marginBottom: theme.spacing(2),
    },
    linkButton: {
        marginRight: theme.spacing(1),
    },
    paymentButton: {
        marginRight: theme.spacing(1),
        color: theme.palette.white,
        backgroundColor: theme.palette.success.main,
        '&:hover': {
            backgroundColor: theme.palette.success.dark
        }
    },
}));

export const getBlankPayment = (): Payment => {
    return {
        __typename: 'Payment',
        id: -1,
        billing_party_member_id: -1,
        billing_party_amount: 0,
        amount: 0,
        timestamp: moment(new Date()).format('YYYY-MM-DD HH:mm:ss'),
        payment_type: PaymentType.CARD,
        payment_status: PaymentStatus.PENDING,
        provider_reference: null,
        provider_status: '',
        provider_response_raw: '',
        reconciled: false,
        groupMemberPayments: [],
        description: '',
        refunds_amount: 0,
    };
};

export const BillingPartyPaymentsList = (props: { billingParty: BillingParty, canEdit: boolean, isAdmin: boolean, groupRef?: string }) => {
    const classes = useStyles();
    const {billingParty, canEdit, isAdmin, groupRef} = props;
    const isNewParty = billingParty.id === -1;
    const [selectedPayment, setSelectedPayment] = useState<Payment | null>(null);
    const [makePayment, setMakePayment] = useState(false);
    const outstandingBalance = billingParty.outstandingBalance || 0;


    return (
        <React.Fragment>
            {!isNewParty && (
                <Card className={classes.container}>
                    <CardHeader title="Billing Party Payments" action={[
                        isAdmin && !isNewParty && isAdmin && (
                            <Button key={1} variant="contained" className={classes.linkButton}
                                    onClick={() => setSelectedPayment(getBlankPayment())}>Add
                                Payment/Transfer</Button>),
                        !isNewParty && (
                            <Button key={2} variant="contained" className={classes.paymentButton}
                                    onClick={() => setMakePayment(true)} disabled={outstandingBalance <= 0}>Make a Payment</Button>),
                    ]}/>
                    <CardContent>
                        <PaymentsListContent billingPartyId={billingParty.id} isAdmin={isAdmin} canEdit={canEdit}
                                             groupRef={groupRef}/>
                    </CardContent>
                </Card>
            )}

            {isAdmin && selectedPayment && (
                <PaymentEditModal onClose={() => setSelectedPayment(null)} open={true} payment={selectedPayment}
                                  setSelectedPayment={setSelectedPayment} billingPartyId={billingParty.id}
                                  isAdmin={isAdmin} canEdit={canEdit}/>
            )}

            {makePayment && (
                <PaymentCheckoutFrame
                    open={true}
                    billingPartyId={billingParty.id}
                    onClose={() => setMakePayment(false)}
                    onSuccess={() => setMakePayment(false)}
                />
            )}
        </React.Fragment>
    );
};

export default BillingPartyPaymentsList;
